import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

/**
 * Handles the Stripe Checkout return flow for the audiobook unlock
 * purchase. When the URL carries `?audiobook_unlock=success` (or
 * `=cancelled`), surfaces a toast, reopens the Audiobook dialog (the
 * webhook has already resumed narration server-side), and cleans the URL.
 */
export function useAudiobookUnlockReturn(onUnlocked) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const flag = searchParams.get('audiobook_unlock');
    if (!flag) return;
    if (flag === 'success') {
      toast.success('Audiobook unlocked — narrating the rest of your novel now.');
      onUnlocked?.();
    } else if (flag === 'cancelled') {
      toast.info('Audiobook unlock cancelled.');
    }
    navigate(window.location.pathname, { replace: true });
  }, [searchParams, navigate, onUnlocked]);
}
